module.exports = __webpack_public_path__ + "static/img/circle.91d2e883.svg";